module.exports = __webpack_public_path__ + "static/media/3day@2x.825ca011.png";